var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33203 14L3.9987 14H13.7112L14.6654 12.9698V8V6.66667H11.6654V4.00002C11.6654 3.00001 10.9987 1.99687 9.66536 2.00001C8.33203 2.00315 7.66536 3 7.66536 4.00001C7.66536 6.00001 5.9987 7.33334 5.33203 7.33334L3.9987 7.33335L2.33203 7.33334L1.33203 8.33337L1.33204 14L3.33203 14ZM2.66536 12.6667L3.9987 12.6667V8.66667L2.9987 8.66668L2.66536 9.02496V12.6667ZM5.33203 12.6667H12.6654L13.332 12V8H10.332V6.66667C10.332 6.66667 10.332 4.66668 10.332 4.00002C10.332 3.66667 10.0336 3.33334 9.66536 3.33334C9.29717 3.33334 8.9987 3.66667 8.9987 4.00002C8.9987 6 6.9987 8.66668 5.33203 8.66667C5.33203 9.33334 5.33203 12.6667 5.33203 12.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.107f29b47394c64f2c72d302b5b45c62.svg";
export { ForwardRef as ReactComponent };